import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {UiService} from '../../services/ui-service/ui.service';
import {Cart} from '../orderSingletone/Cart';
import {Order} from '../orderSingletone/Order';
// import { ReservationFormComponent} from '../reservation-form/reservation-form.component';
declare let fbq:Function;

@Component({
  selector: 'app-bchoose-date',
  templateUrl: './bchoose-date.component.html',
  styleUrls: ['./bchoose-date.component.scss']
})
export class BchooseDateComponent implements OnInit {

  @Input() hall: Object;

  public cart = Cart.getInstance();

  constructor(private router: Router, private UIservice: UiService) {
  }

  openRightMenu = (event: Event): void => {
    $('.rmenu').removeAttr('style');
    if (this.hall) {
      this.cart.order = new Order();
      this.UIservice.setRightMenuActiveStepIndex(1);
      this.cart.order.setSelectedHall(this.hall);
      fbq('track', 'AddToCart'); 
      fbq('track', 'InitiateCheckout'); 
    } else {
      this.UIservice.setRightMenuActiveStepIndex(0);
    }
    this.UIservice.toggleRightMenu(event);
  }

  ngOnInit() {
   
  }

}